


























































import { Component, Vue } from 'vue-property-decorator';
import Product from '@/zenky/interfaces/products/Product';
import axios from '@/zenky/api/Http';
import ItemResponse from '@/zenky/api/responses/ItemResponse';
import { pluralize, variantOptionColor } from '@/helpers/utils';
import Media from '@/zenky/interfaces/media/Media';
import ProductVariant from '@/zenky/interfaces/products/ProductVariant';
import VariantOptionValue from '@/zenky/interfaces/products/VariantOptionValue';

const placeholderImage = require('@/assets/images/icons/photo-camera.svg');

@Component
export default class ProductVariantSidebar extends Vue {
  protected product!: Product;
  protected productIsLoading: boolean = false;
  protected productLoaded: boolean = false;

  created() {
    this.loadProduct();
  }

  get variantsCount() {
    if (!this.productLoaded || !this.product.variants || !this.product.variants.length) {
      return 'Нет вариантов';
    }

    return pluralize(this.product.variants.length, [
      'вариант',
      'варианта',
      'вариантов',
    ]);
  }

  get productImage() {
    if (!this.productLoaded) {
      return placeholderImage;
    } else if (!this.product.media || !this.product.media.length) {
      return placeholderImage;
    }

    const image = this.product.media.find((media: Media) => !!media.thumb_url);

    if (!image) {
      return placeholderImage;
    }

    return image.thumb_url;
  }

  protected loadProduct() {
    if (this.productIsLoading) {
      return;
    }

    this.productIsLoading = true;

    axios.get(`products/${this.productId()}?with=media,variants.option_values.option`)
      .then(({ data }: { data: ItemResponse<Product>}) => {
        this.product = data.data;
        this.generateOptionColors();
        this.productIsLoading = false;
        this.productLoaded = true;
      })
      .catch((err: any) => {
        console.error(err);
        this.productIsLoading = false;
        this.productLoaded = false;
      });
  }

  protected productId() {
    return this.$route.params.id;
  }

  protected generateOptionColors() {
    if (!this.product.variants || !this.product.variants.length) {
      return;
    }

    this.product.variants = this.product.variants.map((variant: ProductVariant) => {
      if (!variant.option_values || !variant.option_values.length) {
        return {
          ...variant,
          options: [],
        };
      }

      const options = variant.option_values.map((item: VariantOptionValue, index: number) => {
        if (!item.option) {
          return null;
        }

        return {
          option: item.option.name,
          value: item.name,
          color: variantOptionColor(index),
        };
      });

      return {
        ...variant,
        options: options.filter((item: any) => !!item),
      };
    });
  }

  protected cardBackground(variant: ProductVariant) {
    if (variant.id === this.$route.params.variantId) {
      return '#e9fffb';
    }

    return '#fff';
  }
}
